import {useContext} from "react";
import {Box, Typography} from "@mui/material";
import Grid from "@mui/material/Grid2";
import {useNavigate} from "react-router-dom";
import {
  BaseWorldListPayload,
  CONTEXT_ACTION_TYPE,
  DataStoreContext,
  DataStoreType,
  WORLD_LIST_STEPS,
  WorldListPayload
} from "../../contexts/OperatingEnvironmentContext";
import {FetchMessage} from "../../../../hooks/useFetchAllQuery";
import SortOrder from "../forms/SortOrder";
import {BASE_WORLD_LIST_SORT_ORDERS, OPERATING_ENVIRONMENT_URLS} from "../../../../constants/constants";
import {sortBaseWorlds} from "../../utils/operatingEnvironmentUtil";
import {BaseWorldListItem} from "../lists/BaseWorldListItem";
import Pjdb1Button from "../../../../components/inputs/Pjdb1Button";

export default function BaseWorldListStep() {
  const {state, dispatch} = useContext(DataStoreContext);
  const navigate = useNavigate();
  const baseWorlds = state.baseWorldList.baseWorlds.map(item => Object.values(item)).flat();

  return (
    <>
      <Grid container alignItems="end" sx={{flexWrap: "nowrap"}} size={{xs: 12}}>
        <Grid size="grow">
          <Typography variant="subtitle1" sx={{fontWeight: "bold"}}>
            検索結果一覧
          </Typography>
        </Grid>
        <Grid size="auto">
          <Grid container alignItems="center" spacing={2} sx={{flexWrap: "nowrap"}}>
            <Grid>
              <Box component="span">
                {baseWorlds.length > 0 ? `${baseWorlds.length.toLocaleString()}件` : ""}
              </Box>
            </Grid>
            <Grid>
              <Box component="span">
                <SortOrder
                  value={state.baseWorldList.searchCond.sortOrder}
                  onChange={(event) => {
                    dispatch({
                      type: CONTEXT_ACTION_TYPE.BASE_WORLD_LIST,
                      payload: {
                        searchCond: {
                          ...state.baseWorldList.searchCond,
                          sortOrder: event.target.value as DataStoreType["baseWorldList"]["searchCond"]["sortOrder"],
                        }
                      } satisfies BaseWorldListPayload
                    });
                  }}
                  items={Object.values(BASE_WORLD_LIST_SORT_ORDERS)}/>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {baseWorlds.length > 0 && (
        <Grid container alignItems="stretch" spacing={2}>
          {sortBaseWorlds(baseWorlds, state.baseWorldList.searchCond.sortOrder)
            .map(item => (
              <Box key={item.attr['world-id']} display='flex' gap={4} onClick={() => {
                navigate(`${OPERATING_ENVIRONMENT_URLS.WORLD_DETAIL.URL}/${item.attr['world-id']}`);
              }}>
                <BaseWorldListItem item={item}>
                  <Pjdb1Button label="カスタムワールド表示" variant='contained' color='info' onClick={(e) => {
                    e.stopPropagation();
                    dispatch({
                      type: CONTEXT_ACTION_TYPE.WORLD_LIST,
                      payload: {
                        step: WORLD_LIST_STEPS.CUSTOM_WORLD,
                        selectedBaseWorld: item,
                        customWorldSearchText: '',
                      } satisfies WorldListPayload
                    });
                  }}/>
                </BaseWorldListItem>
              </Box>
            ))}
        </Grid>
      )}

      <FetchMessage
        data={state.baseWorldList.baseWorlds}
        status={state.baseWorldList.searchStatus}
        isEmpty={(value) => value.length === 0
          || value.every(v => Object.values(v).length === 0)
        }
      />

    </>
  );
}
